<template>
  <div v-if="loaded">
    <FormKit v-model="taskAttrs" type="form" class="mt-4" :actions="false">
      <FormKit type="text" name="name" label="Task Name" />
      <QuillInput
        :model-value="taskAttrs.description"
        name="task-description"
        label="Task Description"
        @update:model-value="value => (taskAttrs.description = value)"
      />
      <FormKit
        type="select"
        label="Assigned to"
        name="assigned_to_role"
        :options="{ agent: 'Agent', other: 'Other' }"
        placeholder="Select a person"
      />
      <FormKit
        v-if="taskAttrs.assigned_to_role === 'other'"
        type="select"
        label="Assigned to"
        name="assigned_to_user_id"
        :options="assignableUsers"
        placeholder="Select a person"
      />
      <FormKit
        type="select"
        label="E-Signature Template"
        :options="templateOptions"
        name="template_id"
        placeholder="Choose a template"
      />
    </FormKit>
  </div>
</template>

<script>
import QuillInput from '../shared/QuillInput.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    QuillInput,
  },
  props: {
    task: {
      required: true,
      type: Object,
    },
    assignableUsers: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      templates: [],
      taskAttrs: {
        name: '',
        description: '',
        template_id: '',
        assigned_to_role: '',
        assigned_to_user_id: '',
      },
      loaded: false,
    };
  },
  computed: {
    templateOptions() {
      return this.templates.map(temp => ({
        value: temp.id,
        label: temp.name,
      }));
    },
  },
  async mounted() {
    await this.fetchEsignatureTemplates();

    this.taskAttrs = {
      ...this.taskAttrs,
      ...this.task,
      template_id: this.task.checklist_taskable.settings?.template_id,
    };
    this.loaded = true;
  },
  methods: {
    async updateTask() {
      const res = await fetch(`/api/task_checklists/${this.task.task_checklist_id}/checklist_tasks/${this.task.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          checklist_task: {
            name: this.taskAttrs.name,
            description: this.taskAttrs.description,
            assigned_to_role: this.taskAttrs.assigned_to_role,
            assigned_to_user_id: this.taskAttrs.assigned_to_user_id,
            order: this.taskAttrs.order,
            checklist_taskable: {
              template_id: this.taskAttrs.template_id,
            },
          },
        }),
      });

      const { status } = await res.json();

      if (status === 'success') {
        const checklistType = this.task.task_checklist.checklist_type;
        await this.$router.push(`/settings/company/${checklistType}_checklists/${this.task.task_checklist_id}/edit`);
        toast.success('Task Updated', {
          action: { label: 'Dismiss' },
          description: 'Your task was successfully updated.  Use the button below to dismiss this alert.',
        });
      }
    },
    async fetchEsignatureTemplates() {
      const res = await fetch(`/api/esignature_templates`);
      const { records } = await res.json();

      this.templates = records;
    },
  },
};
</script>
